export enum QuestionnaireType {
  REGISTER = 'Register',
  EXPERIENCE = 'Experience',
  LOYALTY_SIGNUP = 'Loyalty SignUp',
  ORDER_TRACKER = 'Order Tracker Questionnaire',
}
